import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 text-center text-lg-end order-lg-2">
              <Link to="/privacy-policy">
                <i className="icon-shield"></i>{" "}
                <FormattedMessage id="privacy_policy" />
              </Link>
              <span className="divider">|</span>
              <Link to="/terms-and-conditions">
                <i className="icon-contract"></i>{" "}
                <FormattedMessage id="terms_and_condition" />
              </Link>
              {/* <span ><i className="icon-contract"></i> Terms & Conditions</span> */}
              {/* <Link to="/privacy-policy"><i className="icon-shield"></i> Privacy Policy</Link> 
              <span className='divider'>|</span>
              <Link to="/terms-and-conditions"><i className="icon-contract"></i> Terms & Conditions</Link> */}
            </div>
            <div className="col-lg-6 text-center text-lg-start">
              <p>
                <FormattedMessage id="copyright" /> © 2026{" "}
                <FormattedMessage id="felybeauty_com" />,{" "}
                <FormattedMessage id="all_rights_reserved" />.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
